import { useAuth } from "../context/AuthContext";
import { t } from "../i18n";

export function PrivacyOverlay() {
  const { blurred } = useAuth();
  if (!blurred) return null;
  return (
    <div data-testid="privacy-overlay" onClick={() => window.focus()}
      className="fixed inset-0 z-[3000] backdrop-blur-2xl bg-[#08090a]/95 flex flex-col items-center justify-center gap-4 select-none">
      <span className="w-14 h-14 rounded-full border-[4px] border-[#d4af37]" aria-hidden />
      <p className="text-muted-foreground text-sm">{t("app.protected")}</p>
    </div>
  );
}
